import { Injectable } from '@angular/core';
import { AutoRedemptionSettingFacade } from '@features/auto-redemption-settings/facades/auto-redemption-setting/auto-redemption-setting.facade';
import { LoadAutoRedemptionSettings } from '@features/auto-redemption-settings/store/actions';
import * as actions from '@features/user-preference/store/actions/user-preference.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActionTypes } from '@rd/core/auth/store/actions/auth.actions';
import { UserCustomizationsFacade } from '@rd/core/facades/user-customizations-facade/user-customizations.facade';
import { switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class ApplicationEffects {
  constructor(
    private actions$: Actions,
    private autoRedemptionSettingFacade: AutoRedemptionSettingFacade,
    private userCustomizationsFacade: UserCustomizationsFacade,
  ) {}

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActionTypes.LOGIN_USER),
        take(1),
        tap(() => {
          this.autoRedemptionSettingFacade.getAutoRedemptionSettings();
          this.userCustomizationsFacade.getUserCustomizations();
        }),
      ),
    {
      dispatch: false,
    },
  );

  updatePointsAccountIdSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        actions.UserPreferenceActionTypes.UPDATE_POINTS_ACCOUNT_ID_SUCCESS,
      ),
      switchMap(() => [new LoadAutoRedemptionSettings()]),
    ),
  );
}
